import { createAsyncThunk } from '@reduxjs/toolkit';

import { StatementService } from 'api';

import { StatementData } from 'models';

export const getIncome = createAsyncThunk('statement/getIncome', async (data: StatementData) => {
	return await StatementService.getInterest(data);
});
